import BarChartByUser from './BarChartByUser'
import withBarChartByUser from './withBarChartByUser'

const ConnectedBarChartByUser = withBarChartByUser(BarChartByUser)

export { ConnectedBarChartByUser as BarChartByUser }
